export const PageTypes = {
  PageIndustry: 'PageIndustry',
  PageProductConstruction: 'PageProductConstruction',
  PageProductLine: 'PageProductLine',
};

export enum RelatedTabsTypes {
  RelatedProducts = 'RelatedProducts',
  RelatedProductModel = 'RelatedProductModel',
  RelatedIndustries = 'RelatedIndustries',
  RelatedServices = 'RelatedServices',
  RelatedDocuments = 'Documents',
}

export const types = {
  ALL: 'ALL',
};

export type RelatedItemTag = {
  id: number | string;
  name: string;
};

export type RelatedItem = {
  Title: string;
  Summary?: string;
  PageUrl?: string;
  ImageUrl: string;
  ImageAlt: string;
  USPList?: any[]; // Assuming USPList can be an array of any type
  Tags?: RelatedItemTag[];
  Meta?: any;
};

export type RelatedDocumentItem = RelatedItem & {
  FileName: string;
  Description: string;
  FileSize: string;
  FileCategory: string;
  MimeType: string;
  Url: string;
  Tags: RelatedItemTag;
};

export type RelatedContent = {
  id?: string;
  Items: RelatedItem[] | null;
  Name: string;
  RenderedServiceContentArea: string | null;
  HideRelatedTabs: boolean;
  StandardPages: RelatedItem[] | null;
};

export type RelatedServices = RelatedContent & {
  HideServiceList?: boolean;
};

export type RelatedDocuments = RelatedContent & {
  id: 'Documents';
  Items: RelatedDocumentItem[] | null;
  CustomDocumentTabText: string;
  CustomDocumentTabContentArea: string;
};

export type ProductModelTopic = {
  Name: string;
  Content: string;
  Order: number;
};

export type ProductModelImages = {
  ImageAltText: string;
  IsMain: boolean;
  Order: number;
  Thumbnail: string;
  WebpLarge: string;
  WebpMedium: string;
};

export type ProductModelItem = {
  Images: ProductModelImages[];
  LanguageCode: string;
  ProductConstructionPageId: string;
  ProductLinePageId: string;
  ProductModelId: string;
  ProductName: string;
  ProductModelDisplayName: string;
  ProductDescription?: string;
  Topics: ProductModelTopic[];
};

export type RelatedProductModelItem = RelatedItem & {
  ProductId: string;
  ProductDescription: string;
  ProductTitle: string;
  ProductImageUrl: string;
  ProductImageAlt: string;
  TechnicalDataViewModels?: ProductModelItem[];
};

export interface RelatedProductModel extends RelatedContent {
  Items: RelatedProductModelItem[];
}

export type RelatedTabs = {
  MyProperty: number;
  RelatedProducts: RelatedContent | null;
  RelatedProductModel: RelatedProductModel | null;
  RelatedIndustries: RelatedContent | null;
  RelatedServices: RelatedServices | null;
  Documents: RelatedContent | null;
  I18n: Record<string, string>;
  Tags: RelatedItemTag[] | null;
  OtherTabLocalizedName: string;
};

export const isRelatedDocuments = (
  tab: RelatedContent | RelatedDocuments
): tab is RelatedDocuments => {
  return tab.id === 'Documents';
};
